import * as type from '@/utvStore/store/mutation-types'
import { LOGIC_API } from '@/utvStore/store/API'
import pushErrorMessage from '@/utils/pushErrorMessage'

const axiosInstance = axios.create({
  timeout: 8000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  }
})

const initialState = {
  result: {}
}

const createData = (data = {}) => JSON.stringify(data)

const state = Object.assign({}, initialState)

const getters = {
  hasTrialResult: state =>
    state.result.result_data ? state.result.result_data.length > 0 : false
}

const actions = {
  [type.GET_TRIAL_RESULT]({ commit }, data) {
    return axiosInstance.post(LOGIC_API.result, createData(data)).then(
      res => {
        commit(type.GET_TRIAL_RESULT, res.data)
      },
      error => {
        error = pushErrorMessage(error)
        return Promise.reject(error)
      }
    )
  },
  [type.RESET_TRIAL_RESULT]({ commit }) {
    commit(type.RESET_TRIAL_RESULT)
  }
}

const mutations = {
  [type.GET_TRIAL_RESULT](_state, result = {}) {
    Object.assign(_state, { result })
  },
  [type.RESET_TRIAL_RESULT](_state) {
    Object.assign(_state, { result: {} })
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/trial.js